/* @refresh reload */
import { render } from "solid-js/web";
import App from "./App";
import "./shared/styles/base.css";
import "./shared/styles/legacy.css";

const root = document.getElementById("root");
if (!root) throw new Error('missing mount point: no element with id "root"');

render(() => <App />, root);
